import { PUBLIC_URL } from "../env";
import { setRedirect } from "../pullRequestRedirect";

/**
 * The path this bundle is deployed under, without a trailing slash. Empty on
 * normal deploys, `/_pr/<sha>` on pull request builds.
 */
export const BASE_PATH = PUBLIC_URL ? PUBLIC_URL.replace(/\/+$/, "") : "";

/**
 * Prefix a router-relative path with the deploy base path. Use this whenever a
 * full page navigation (`window.location` / `window.open`) is built from a path
 * that would otherwise be handled by the router basename.
 */
export const withBasePath = (path: string) =>
    `${BASE_PATH}${path.startsWith("/") ? "" : "/"}${path}`;

/**
 * Inverse of withBasePath: turn a browser pathname into a router-relative path.
 * Only strips on a segment boundary, so a base path of `/_pr/abc123` leaves
 * `/_pr/abc1234/...` alone.
 */
export const stripBasePath = (pathname: string) => {
    if (!BASE_PATH) {
        return pathname;
    }
    if (pathname === BASE_PATH) {
        return "/";
    }
    return pathname.startsWith(`${BASE_PATH}/`)
        ? pathname.slice(BASE_PATH.length)
        : pathname;
};

/**
 * Full page navigation to a router-relative path.
 *
 * On a pull request build cloudfront only serves the bundle at the base path
 * itself -- any deeper url is answered with master's index.html, which flashes
 * the master app before RedirectToPullRequestRoute bounces back here. Park the
 * target and load the base path directly instead, so RedirectToAccount picks it
 * up without the detour.
 */
export const navigateTo = (path: string) => {
    if (!BASE_PATH) {
        window.location.href = path;
        return;
    }
    const queryStart = path.indexOf("?");
    const [pathname, search] =
        queryStart === -1
            ? [path, ""]
            : [path.slice(0, queryStart), path.slice(queryStart)];
    setRedirect(pathname, search);
    // Without a trailing slash: the url shape the PR build is published under,
    // and the one RedirectToPullRequestRoute already redirects to.
    window.location.href = BASE_PATH;
};
